const config = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  GRAPHQL_ENDPOINT: process.env.REACT_APP_API_ENDPOINT + '/graphql',
}

export default config